// Remember URL params for the session and fill matching form fields when the URL lacks them.
(function () {
  const KEY = 'urlParams';
  const read = () => { try { return JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch (e) { return {}; } };

  const stored = read();
  const current = new URLSearchParams(location.search);
  current.forEach((v, k) => { stored[k] = v; });
  try { sessionStorage.setItem(KEY, JSON.stringify(stored)); } catch (e) {}

  const fill = () => {
    document.querySelectorAll('[data-param]').forEach((el) => {
      const p = el.dataset.param;
      if (!current.has(p) && stored[p] && !el.value) el.value = stored[p];
    });
  };

  document.addEventListener('DOMContentLoaded', fill);
  document.addEventListener('gform_post_render', fill);
  if (window.jQuery) jQuery(document).on('gform_post_render', fill);
})();
